import { Controller } from "@hotwired/stimulus"

// Drives the 3-step give flow entirely client-side. Only submits on Step 3.
export default class extends Controller {
  static targets = [
    "step",
    "amountChip", "amountInput", "amountDisplay",
    "frequencyChip", "frequencyInput",
    "fundChip", "fundInput",
    "methodRow", "methodInput",
    "continueLabel", "payLabel"
  ]
  static values = { step: { type: Number, default: 1 } }

  connect() {
    this.render()
  }

  next(e)  { e.preventDefault(); this.stepValue = Math.min(3, this.stepValue + 1); this.render() }
  back(e)  { e.preventDefault(); this.stepValue = Math.max(1, this.stepValue - 1); this.render() }

  setAmount(e) {
    const v = parseInt(e.currentTarget.dataset.amount, 10)
    this.amountInputTarget.value = v
    this.render()
  }

  amountInputChanged(e) {
    // "custom amount" free-text field
    const v = parseInt(e.currentTarget.value, 10) * 100 // rupees → paise
    if (!Number.isNaN(v)) this.amountInputTarget.value = v
    this.render()
  }

  setFrequency(e) {
    const v = e.currentTarget.dataset.frequency
    this.frequencyInputTarget.value = v
    this.frequencyChipTargets.forEach(el => {
      const active = el.dataset.frequency === v
      el.classList.toggle("chip-selected", active)
    })
  }

  setFund(e) {
    const v = e.currentTarget.dataset.fund
    this.fundInputTarget.value = v
    this.fundChipTargets.forEach(el => {
      const active = el.dataset.fund === v
      el.classList.toggle("chip-selected", active)
    })
  }

  setMethod(e) {
    const v = e.currentTarget.dataset.method
    this.methodInputTarget.value = v
    this.methodRowTargets.forEach(el => {
      const active = el.dataset.method === v
      el.classList.toggle("border-ac", active)
      el.classList.toggle("bg-panel", active)
    })
    // Show/hide the UPI QR panel
    const qr = this.element.querySelector("[data-give-wizard-qr]")
    if (qr) qr.hidden = v !== "upi"
  }

  render() {
    const amount = parseInt(this.amountInputTarget.value, 10)
    this.amountChipTargets.forEach(el => {
      el.classList.toggle("chip-selected", parseInt(el.dataset.amount, 10) === amount)
    })
    // step visibility
    this.stepTargets.forEach(s => {
      s.hidden = parseInt(s.dataset.stepNum, 10) !== this.stepValue
    })
    // amount labels
    const paise   = parseInt(this.amountInputTarget.value || 0, 10)
    const rupees  = Math.round(paise / 100)
    const display = "₹" + rupees.toLocaleString("en-IN")
    if (this.hasAmountDisplayTarget) this.amountDisplayTarget.textContent = display
    if (this.hasContinueLabelTarget) this.continueLabelTarget.textContent = "Continue · " + display
    if (this.hasPayLabelTarget)      this.payLabelTarget.textContent      = "Pay " + display
  }
}
